import * as React from "react";
import { locKeys } from "./l10n";
import { LocalizedText } from "bernie-l10n";

export const PackageDisabledMessage = ({
  disablePackageOptions,
  totalTravelers
}: {
  disablePackageOptions?: boolean;
  totalTravelers: number;
}) => {
  if (!disablePackageOptions) {
    return null;
  }

  const message = totalTravelers > 6 ? locKeys.invalidNumberOfTravelersForPackage : locKeys.packageDisabledMessage;

  const pdmPaddings = "m-l-padding-four l-l-padding-four xl-l-padding-four";

  return (
    <div className={`uitk-type-paragraph-300 packageDisabledMessage ${pdmPaddings}`}>
      <p>
        <LocalizedText message={message} />
      </p>
    </div>
  );
};
